import { MouseEvent, useCallback } from 'react';
import { TMultiSelectItem } from '../../ui/multi-select';

export const useHandlers = <T>(selected: TMultiSelectItem<T>[], onChange?: (value: T[]) => void) => {
  const tagRemoveHandler = useCallback(
    (tag: TMultiSelectItem<T>) => {
      onChange && typeof onChange === 'function' &&
        onChange(
          selected.filter(el => el.value !== tag.value).map(el => el.value),
        );
    },
    [onChange, selected],
  );

  const closeIconHandler = (e: MouseEvent) => {
    e.stopPropagation();
    onChange && onChange([]);
  };

  return {
    tagRemoveHandler,
    closeIconHandler
  };
};
